import { apiURL, axiosInstance } from 'constants/config';
import {
  loadVouchersFail,
  loadVouchersRequested,
  loadVouchersSuccess,
  storeVoucherFail,
  storeVoucherRequested,
  storeVoucherSuccess,
  updateVoucherFail,
  updateVoucherRequested,
  updateVoucherSuccess,
  archiveVoucherRequested,
  archiveVoucherFail,
  archiveVoucherSuccess,
  storeCustomerVoucherRequested,
  storeCustomerVoucherFail,
  storeCustomerVoucherSuccess,
} from './voucherSlice';
import { call, put, takeEvery } from 'redux-saga/effects';
import toast from 'react-hot-toast';
import { loadCustomerEffect } from 'store/customers/sagas';

export function* loadVouchersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/vouchers?SearchValue=${
        action?.payload?.filters?.query ?? ''
      }&PaginationOption.Page=${
        action.payload.page
      }&PaginationOption.PageSize=${action.payload.perPage}&reference=${
        action.payload?.filters?.reference ?? ''
      }`
    );
    if (data?.succeeded) {
      yield put(loadVouchersSuccess(data));
    }
  } catch (error: any) {
    yield put(loadVouchersFail(error.meessage));
  }
}

export function* storeVoucherEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {

    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/vouchers`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeVoucherSuccess(data));
      yield call(loadCustomerEffect, {
        payload: { reference: action?.payload?.customerReference },
        type: '',
      });
      toast.success('Voucher created successfully');
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(storeVoucherFail(error.message));
  }
}

export function* storeCustomerVoucherEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/vouchers`,
      action.payload
    );

    if (data?.succeeded) {
      yield put(storeCustomerVoucherSuccess(data));
      yield call(loadCustomerEffect, {
        payload: { reference: action?.payload?.customerReference },
        type: '',
      });
      yield call(loadVouchersEffect, {
        payload: {
          filters: { reference: action?.payload?.customerReference },
          page: 1,
          perPage: 10,
        },
        type: '',
      });
      toast.success('Voucher created successfully');
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(storeCustomerVoucherFail(error.message));
  }
}

export function* updateVoucherEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/vouchers/${action.payload?.id}`,
      action?.payload
    );
    if (data?.succeeded) {
      yield put(updateVoucherSuccess(data));
      yield call(loadVouchersEffect, {
        payload: { filters: {}, page: 1, perPage: 10 },
        type: '',
      });
      toast.success('Voucher updated successfully');
    }
  } catch (error: any) {
    yield put(updateVoucherFail(error.message));
  }
}

export function* archiveVoucherEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { item } = action.payload;

    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/vouchers/${action.payload?.item?.id}`,
      action.payload?.item
    );
    if (data?.succeeded) {
      yield put(archiveVoucherSuccess(data));
      yield call(loadVouchersEffect, {
        payload: { page: 1, perPage: 10 },
        type: '',
      });
      if (item.isActive) {
        toast.success('Voucher archived successfully');
      } else {
        toast.success('Voucher unarchived successfully');
      }
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(archiveVoucherFail(error.message));
  }
}

export function* vouchersSaga(): Generator<any, void, any> {
  yield takeEvery(loadVouchersRequested, loadVouchersEffect);
  yield takeEvery(storeVoucherRequested, storeVoucherEffect);
  yield takeEvery(updateVoucherRequested, updateVoucherEffect);
  yield takeEvery(archiveVoucherRequested, archiveVoucherEffect);
  yield takeEvery(storeCustomerVoucherRequested, storeCustomerVoucherEffect);
}
